import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clubQueryKeys } from "./clubQueryKeys";

export function useMutationClubTerms({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      clubId,
      payload,
    }: {
      clubId: number;
      payload: FormData;
    }) => {
      return (await api.clubApi.updateTerms(clubId, payload)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: clubQueryKeys.all() });
    },
  });
}
